import { COLORS } from '../../../components/Selects/SelectColor';

// Подсказка «такая машина уже есть» при вводе VIN на экране нового автомобиля.
// Правила разбора строки те же, что на бэке (CarsController.NormalizeVinQuery).

export const MIN_VIN_SEARCH_LENGTH = 8;
export const FULL_VIN_LENGTH = 17;

export const vinSearchQuery = (value) => {
  const normalized = String(value || '')
    .replace(/[^0-9a-z]/gi, '')
    .toUpperCase();
  return normalized.length < MIN_VIN_SEARCH_LENGTH ? null : normalized;
};

// Цвет в базе лежит hex-кодом: менеджеру показываем название из справочника, а неизвестный hex — не показываем вовсе.
export const colorName = (value) => {
  const color = String(value || '').trim();
  if (!color) return '';
  const known = COLORS.find((item) => item.value.toLowerCase() === color.toLowerCase());
  if (known) return known.label;
  return color.startsWith('#') ? '' : color;
};

// «Марка Модель, 2021, белый» — только то, что известно.
export const carSummary = (car) =>
  [[car?.mark, car?.model].filter(Boolean).join(' '), car?.issueYear, colorName(car?.color)].filter(Boolean).join(', ');

// Полное совпадение подсвечиваем: ввели весь VIN, а такая машина уже заведена.
export const isSameVin = (car, value) =>
  String(value || '').trim().length === FULL_VIN_LENGTH &&
  String(car?.vin || '').toUpperCase() === String(value).trim().toUpperCase();

// Подсветка в списке подсказок: по кругу вверх/вниз.
export const nextIndex = (current, delta, length) => (length ? (((current + delta) % length) + length) % length : 0);

// Что подсвечено сразу: машина с полностью совпавшим VIN, иначе первая — Enter сразу выбирает её.
export const initialIndex = (cars, value) => {
  const exact = (cars || []).findIndex((car) => isSameVin(car, value));
  return exact >= 0 ? exact : 0;
};
